// Small popup above the DRAWING button letting the user choose which part's
// technical drawing to view. Only parts that actually have a drawing are listed.

export default function DrawingMenu({ options, onPick, onClose }) {
  return (
    <>
      {/* click-away catcher */}
      <div className="fixed inset-0 z-20" onClick={onClose} />
      <div
        className="absolute bottom-full left-0 mb-2 z-30 bg-white rounded-md shadow-lg border border-gray-200 py-1 min-w-[130px]"
        role="menu"
      >
        {options.map((o) => (
          <button
            key={o.key}
            role="menuitem"
            onClick={() => onPick(o.key)}
            className="block w-full text-left px-4 py-1.5 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-colors"
          >
            {o.label}
          </button>
        ))}
      </div>
    </>
  );
}
